module.exports = __webpack_public_path__ + "img/second-page-icon-4.c6fec915.svg";